import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { Google_map } from 'src/app/shared/google_map';
import { Gps } from 'src/app/shared/gps';
import { Geoutil } from 'src/app/shared/geoutil';

@Component({
  selector: 'app-polygon',
  templateUrl: './polygon.component.html',
  styleUrls: ['./polygon.component.css']
})
export class PolygonComponent extends BaseComponent implements OnInit {
  @ViewChild('pagemap', { static: true }) mapElement: any = {};
  google_map: Google_map;
  gps: Gps;
  showMenu = false;
  polygon: any = []; //list of latlng points
  markers: any = [];
  actionid = 1;
  actions = [
    { id: 1, name: "define points" },
    { id: 2, name: "evaluate point" }
  ]

  constructor(injector: Injector) { super(injector) }

  ngOnInit(): void {
    
  }

  async initMap() {
    this.gps = new Gps();
    let { ok, data }: any = await this.gps.getLocation();
    if (!ok) return this.error("Cannot get GPS location: ", data);

    const latlng = data;

    this.google_map = new Google_map();
    this.google_map.init(this.mapElement.nativeElement, latlng, 15);
    this.google_map.setMarker(latlng, "My current location");
    this.showMenu = true;

    this.google_map.clickOnMap((res: any) => {
      let latlng = res.latLng.toJSON();
      if (this.actionid == 1) {
        this.polygon.push(latlng);
        let marker = this.google_map.setMarker(latlng, "Poly");
        this.markers.push(marker);
      };
      if (this.actionid == 2) {
        let odd = Geoutil.pointInPolygon(this.polygon, latlng);
        if (odd){
          this.alert.success("inside polygon");
        }else{
          this.alert.info("outside polygon");
        }
      }
    })
  }

  clear() {
    this.polygon = [];
    this.actionid = 1;
    // this.markers.forEach((marker: any) => {
    //   this.google_map.removeMarkers(marker);
    // })
    // this.markers = [];
    this.initMap();
  }
  createPolygon() {
    this.actionid = 2; //from now on find in and out
    this.markers.forEach((marker: any) => {
      this.google_map.removeMarkers(marker);
    });
    let poly = [];
    this.polygon.forEach((p: any) => {
      poly.push(p);
    });
    poly.push(this.polygon[0]);
    this.google_map.addPolygon(poly);
  }
}
